// Color palette
export const colors = {
  // Primary colors
  primary: '#0D0D0D',
  white: '#FFFFFF',
  
  // Background colors
  bgLight: '#F5F5F5',
  bgMuted: '#FAFAFA',
  navBg: '#F0F0F0',
  
  // Border colors
  border: '#E5E5E5',
  
  // Text colors
  textPrimary: '#0D0D0D',
  textMuted: '#999999',
  textMedium: '#666666',
  
  // Accent colors
  accentBlue: '#18A0FB',
  accentGreen: '#9ef34a',
  
  // Shadow colors
  shadow: 'rgba(0, 0, 0, 0.08)',
  shadowLight: 'rgba(0, 0, 0, 0.05)',
};

// Spacing scale (based on 4px grid)
export const spacing = {
  xs: '0.25rem',    // 4px
  sm: '0.5rem',     // 8px
  md: '0.75rem',    // 12px
  base: '1rem',     // 16px
  lg: '1.5rem',     // 24px
  xl: '2rem',       // 32px
  '2xl': '3rem',    // 48px
  '3xl': '4rem',    // 64px
};

// Typography sizes
export const fontSize = {
  xs: '0.75rem',    // 12px
  sm: '0.875rem',   // 14px
  base: '1rem',     // 16px
  lg: '1.125rem',   // 18px
  xl: '1.25rem',    // 20px
  '2xl': '1.5rem',  // 24px
  '3xl': '1.875rem', // 30px
  '4xl': '2.25rem',  // 36px
  '5xl': '3rem',     // 48px
  '6xl': '3.75rem',  // 60px
  '7xl': '4.5rem',   // 72px
  '8xl': '6rem',     // 96px
};

// Border radius
export const borderRadius = {
  sm: '0.25rem',    // 4px
  base: '0.5rem',   // 8px
  md: '0.75rem',    // 12px
  lg: '1rem',       // 16px
  full: '9999px',   // Full rounded
  pill: '100px',    // Pill shape
};

// Shadows
export const shadows = {
  sm: '0 1px 2px rgba(0, 0, 0, 0.05)',
  base: '0 2px 8px rgba(0, 0, 0, 0.08)',
  md: '0 2px 24px rgba(0, 0, 0, 0.08)',
  lg: '0 4px 16px rgba(0, 0, 0, 0.1)',
};

// Z-index scale
export const zIndex = {
  base: 0,
  dropdown: 1000,
  sticky: 1020,
  fixed: 1030,
  modal: 1040,
  popover: 1050,
  tooltip: 1060,
};

// Breakpoints (matching Tailwind defaults)
export const breakpoints = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
};

// Animation durations
export const animation = {
  fast: '0.15s',
  base: '0.3s',
  slow: '0.5s',
  slower: '0.8s',
};

// Max widths
export const maxWidth = {
  xs: '20rem',      // 320px
  sm: '24rem',      // 384px
  md: '28rem',      // 448px
  lg: '32rem',      // 512px
  xl: '36rem',      // 576px
  '2xl': '42rem',   // 672px
  '3xl': '48rem',   // 768px
  '4xl': '56rem',   // 896px
  '5xl': '64rem',   // 1024px
  '6xl': '72rem',   // 1152px
  '7xl': '80rem',   // 1280px
  full: '100%',
  screen: '100vw',
  container: '1920px',
};

// Export all theme values
export const theme = {
  colors,
  spacing,
  fontSize,
  borderRadius,
  shadows,
  zIndex,
  breakpoints,
  animation,
  maxWidth,
};

export default theme;

